"use client";
import { RuntimeConfig } from "@/lib/runtimeConfig";
import Script from "next/script";
export default function GoogleAnalytics() {
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${RuntimeConfig.GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="ga-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){ dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          gtag('config', '${RuntimeConfig.GA_MEASUREMENT_ID}');
          console.log('GA Initialized');
        `}
      </Script>
    </>
  );
}
